import { ChakraProvider } from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "react-query";
import { Navigate, Route, Routes } from "react-router-dom";
import { publisherPanelTheme } from "./ui/themes/publisherPanelTheme";
import { AuthProvider } from "./services/auth/AuthProvider";
import { PublisherPanelProtectedRoute } from "./services/api/Routing/PublisherPanelProtectedRoute";
import { CabinetLayout } from "./ui/layouts/CabinetLayout/CabinetLayout";
import { LoginPage } from "./pages/LoginPage/LoginPage";
import { NoAccessPage } from "./pages/NoAccessPage/NoAccessPage";
import { BooksPage } from "./features/books/BooksPage";
import { BookEditPage } from "./features/books/BookEditPage";
import { StatisticsPage } from "./features/statistics/StatisticsPage";
import { CampaignsPage } from "./features/campaigns/CampaignsPage";
import { BalancePage } from "./features/balance/BalancePage";
import { PublishersPage } from "./features/publishers/PublishersPage";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

// Mounted in src/App.tsx under path="publishers/panel/*", outside the shop's
// Layout — the panel keeps its own CabinetLayout, theme and auth context.
// Route paths here are relative to that mount point.
const PublisherPanelApp = () => (
  <QueryClientProvider client={queryClient}>
    <ChakraProvider theme={publisherPanelTheme}>
      <AuthProvider>
        <Routes>
          <Route path="login" element={<LoginPage />} />
          <Route path="no-access" element={<NoAccessPage />} />

          <Route
            element={
              <PublisherPanelProtectedRoute>
                <CabinetLayout />
              </PublisherPanelProtectedRoute>
            }
          >
            <Route index element={<Navigate to="books" replace />} />
            <Route path="books" element={<BooksPage />} />
            <Route path="books/new" element={<BookEditPage />} />
            <Route path="books/:id/edit" element={<BookEditPage />} />
            <Route path="statistics" element={<StatisticsPage />} />
            <Route path="campaigns" element={<CampaignsPage />} />
            <Route path="balance" element={<BalancePage />} />
            <Route path="publishers" element={<PublishersPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/publishers/panel" replace />} />
        </Routes>
      </AuthProvider>
    </ChakraProvider>
  </QueryClientProvider>
);

export default PublisherPanelApp;
